import React, { useEffect } from 'react'
import { useGetZMPSetting } from '../hooks/useGetZMPSetting'
import { alpha, Button, Checkbox, createTheme, darken, lighten, MantineProvider, Modal } from '@mantine/core'
import { ModalsProvider } from '@mantine/modals'
import { DatesProvider } from '@mantine/dates'

import 'dayjs/locale/vi';

interface Props {
  children: React.ReactNode
}

export const ZMPProvider: React.FC<Props> = ({ children }) => {
  const { data: zmpSetting, isPending, isError } = useGetZMPSetting()

  useEffect(() => {
    // Chỉ chạy trong môi trường client
    if (typeof document !== 'undefined') {
      const htmlElement = document.documentElement
      htmlElement.style.setProperty(
        '--color-primary-brand',
        zmpSetting?.themes?.color_primary_brand ?? ''
      )
      htmlElement.style.setProperty(
        '--color-primary-on-brand',
        zmpSetting?.themes?.color_primary_on_brand ?? ''
      )
    }
  }, [zmpSetting])

  if (isError) {
    return (
      <div className="zmp-error">
        <img src="/images/error.png" alt="Error" />
        <p>Đã có lỗi xảy ra. Vui lòng thử lại sau.</p>
      </div>
    )
  }
  
  if (isPending) {
    return (
      <div className="zmp-loading" />
    )
  }

  const colorPrimaryBrand = zmpSetting?.themes?.color_primary_brand ?? '#222222'

  const primaryColors = [
    lighten(colorPrimaryBrand, 0.45),
    lighten(colorPrimaryBrand, 0.35),
    lighten(colorPrimaryBrand, 0.25),
    lighten(colorPrimaryBrand, 0.15),
    lighten(colorPrimaryBrand, 0.05),
    alpha(colorPrimaryBrand, 1),
    darken(colorPrimaryBrand, 0.05),
    darken(colorPrimaryBrand, 0.15),
    darken(colorPrimaryBrand, 0.25),
    darken(colorPrimaryBrand, 0.35)
  ]

  const theme = createTheme({
    cursorType: 'pointer',
    colors: {
      brand: primaryColors as any,
    },
    primaryColor: 'brand',
    components: {
      Checkbox: Checkbox.extend({
        // vars: (theme, props) => {
        //   return {
        //     root: {
        //       '--checkbox-color': 'red'
        //     }
        //   }
        // },
        styles: (theme) => ({
          
        }),
      }),
      Button: Button.extend({
        defaultProps: {
          radius: 'xl',
          size: 'md',
        }
      }),
      Modal: Modal.extend({
        styles: {
          content: {
            marginLeft: 'var(--app-shell-left)',
            marginRight: 'auto',
          }
        }
      })
    }
  });

  return (
    <MantineProvider theme={theme}>
      <DatesProvider settings={{ locale: 'vi' }}>
        <ModalsProvider labels={{ confirm: 'Xác nhận', cancel: 'Đóng' }} modalProps={{ centered: true }}>
          {children}
        </ModalsProvider>
      </DatesProvider>
    </MantineProvider>
  )
}
